var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtVivreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artVivreIcon",
    clipPath: "url(#clip-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_yin_yang_1089334",
    transform: "translate(-5.689 -4.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_28860",
    d: "M25.536,37.721a2.935,2.935,0,1,0-2.941-2.936A2.931,2.931,0,0,0,25.536,37.721ZM25.693,45a20,20,0,1,0-20-20A20.025,20.025,0,0,0,25.693,45ZM25.536,11.71a2.94,2.94,0,1,1-2.941,2.938A2.937,2.937,0,0,1,25.536,11.71ZM25.693,25h0c14.017-6.858,5.822-18.258,0-18.258a18.26,18.26,0,1,1,0,36.52C19.857,43.262,11.683,31.863,25.693,25Z",
    fill: "#ee6c88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtVivreIcon);
export default __webpack_public_path__ + "static/media/art-vivre-icon.33a36ed99d331302ba8a86fcadc20a4f.svg";
export { ForwardRef as ReactComponent };